
import { DATA_OPERATIONS } from '../../reducers/data';

export default function getOperationsForModification(modification) {
    return DATA_OPERATIONS.filter(item => {
        return modification
            ? (modification.opId.indexOf(item.id) !== -1)
            : false;
    });
}
